import React, { useEffect, useState } from 'react'

// Эмодзи флаги для основных стран
const FlagEmojis = {
  RU: '🇷🇺', // Россия
  BY: '🇧🇾', // Беларусь
  BG: '🇧🇬', // Болгария
  AZ: '🇦🇿', // Азербайджан
  GR: '🇬🇷', // Греция
  KZ: '🇰🇿', // Казахстан
  UZ: '🇺🇿'  // Узбекистан
}

// Функция для получения кода эмодзи в формате для Twemoji CDN
function getEmojiCodePoint(emoji) {
  return Array.from(emoji)
    .map(char => char.codePointAt(0).toString(16))
    .filter(code => !code.startsWith('fe0f')) // Убираем вариационные селекторы
    .join('-')
}

// Функция для преобразования эмодзи в изображение Twemoji
function emojiToTwemoji(emoji) {
  const codePoint = getEmojiCodePoint(emoji)
  const url = `https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/${codePoint}.svg`
  return `<img src="${url}" alt="${emoji}" style="width: 1.75rem; height: 1.75rem; display: block; vertical-align: middle;" />`
}

function CountryFlag({ countryCode, className, style, title }) {
  const [emojiHtml, setEmojiHtml] = useState('')
  
  const emoji = FlagEmojis[countryCode]
  
  // Преобразование эмодзи в изображения через Twemoji CDN
  useEffect(() => {
    if (!emoji) return
    
    const html = emojiToTwemoji(emoji)
    setEmojiHtml(html)
  }, [emoji, countryCode])
  
  if (!emoji) {
    return (
      <span className={className} style={style} title={title}>
        [{countryCode || '??'}]
      </span>
    )
  }
  
  return (
    <span 
      className={className} 
      style={{
        ...style,
        display: 'inline-block',
        verticalAlign: 'middle',
        lineHeight: '0',
        marginRight: '0.5rem'
      }} 
      title={title || countryCode}
      aria-label={title || countryCode}
      role="img"
      dangerouslySetInnerHTML={{ __html: emojiHtml || emoji }}
    />
  )
}

export default CountryFlag

